<rt-box variant="padding-small" [attr.margin-bottom]="marginBottom() ? '' : null">
  <div class="hidden-evaluations" [class.short]="short()">
    <rt-icon size="medium" name="visibility-off" colorToken="colorIconDisabled" />

    <div class="hidden-evaluations__container" margin-left-medium>
      @if (isJobNameVisible() && offer) {
        <div class="hidden-evaluations__job">
          <div class="job">
            <rt-offer-status-indicator [offerStatus]="offer" margin-right-small-xx />
            <rt-truncate>{{ offer.title }}</rt-truncate>
          </div>
        </div>
      }

      <div class="hidden-evaluations__content">
        @if (short() && !admin) {
          <a class="hidden-evaluations__heading" (click)="counterClick.emit()">
            {{ translations.infobox.headingShort | translate: { count: count() } }}
          </a>
          @if (hasAccessToJob()) {
            <span>
              {{ translations.infobox.messageShort | translate: { count: count() } }}
            </span>
          }
        }
        @if (!short() && admin) {
          <span class="hidden-evaluations__heading">
            {{
              translations.infobox.headingAdmin
                | translate: { count: count(), admin: admin.firstName + ' ' + admin.lastName }
            }}
          </span>
          <span>
            {{ translations.infobox.messageAdmin | translate: { count: count() } }}
          </span>
        }
        @if (!short() && !admin) {
          <span class="hidden-evaluations__heading">
            {{ translations.infobox.heading | translate: { count: count() } }}
          </span>
          <span>
            {{
              hasAccessToJob()
                ? ('app.unbiased_hiring.infobox.message_v2' | translate)
                : (translations.infobox.messageWithNoAccessToJob | translate)
            }}
          </span>
        }
      </div>

      <div
        layout
        layout-horizontal
        [attr.layout-align-items-center]="canReveal() ? '' : null"
        [attr.layout-align-items-end]="canReveal() ? null : ''"
        [attr.margin-top-small]="canReveal() ? '' : null"
        [attr.margin-left-auto]="short() ? '' : null"
      >
        @if (members().length) {
          <rt-admins-avatars
            [limit]="5"
            [admins]="members()"
            [stacked]="true"
            [isShort]="true"
            [renderAdminTooltip]="renderAdminTooltip"
            [attr.margin-top-small]="short() || canReveal() ? null : ''"
            [style.height]="isButtonsVisible() && canReveal() ? '3.6rem' : 'auto'"
          />
        }
        @if (canReveal() && hasAccessToJob()) {
          <rt-button
            (click)="revealClick.emit()"
            [variant]="'tertiary'"
            class="review-evaluations-button"
            margin-left
          >
            <rt-icon name="visibility" />
            {{ 'app.unbiased_hiring.infobox.reveal_for_me' | translate }}
          </rt-button>
        }
      </div>
    </div>

    @if (isButtonsVisible() && hasAccessToJob()) {
      <div class="hidden-evaluations__buttons">
        <rt-group>
          <rt-button
            variant="outline"
            [rtTooltip]="translations.evaluateWithFormTooltip | translate"
            [rtTooltipMaxWidth]="360"
            (click)="evalDropdown.open = true"
            #defaultEvalDropdownTrigger="rtOverlayOrigin"
            rt-overlay-origin
            margin-right-small-x
          >
            <rt-icon name="assignment" />
            <span>{{ translations.evaluateWithForm | translate }}</span>
          </rt-button>

          <rt-icon-button
            variant="outline"
            [rtTooltip]="translations.addQuickEvaluationTooltip | translate"
            (click)="
              quickEvaluationClick.emit({ offerId: correctOffer.id!, context: 'hiddenEvaluations' })
            "
            iconName="rating-thumbs-up-down"
            shape="square"
          />
        </rt-group>

        <ng-template
          #evalDropdown="rtConnectedOverlay"
          [origin]="defaultEvalDropdownTrigger"
          (backdropClick)="evalDropdown.open = false"
          rt-connected-overlay
          hasBackdrop
        >
          <rt-add-evaluation-dropdown
            [offers]="[correctOffer]"
            [templates]="templates()!"
            [dropdownRef]="evalDropdown"
            [fromHiddenEvaluations]="true"
            [forceNestedDropdown]="'evaluationForms'"
            [candidateId]="candidateId()"
            (submit)="onSubmit($event)"
          />
        </ng-template>
      </div>
    }
  </div>
</rt-box>
